<template>
  <div
    class="start-consultation-screen flex flex-col justify-center items-start px-[16px] pt-[24px] md:p-0 md:mt-[60px] max-w-[450px] mx-auto mt-28"
  >
    <h1 :class="themeHeadingClasses" class="text-left leading-[1.4]">{{ startScreenAgreement.title }}</h1>
    <div class="mt-[14px] md:mt-[26px] text-left" v-if="startScreenAgreement.body">
      {{ startScreenAgreement.body }}
    </div>

    <ul class="flex flex-col list-disc w-full mt-[12px] px-[24px] py-[14px] md:pl-[36px] md:pr-[48px] md:max-w-[600px]">
      <li
        class="mb-[5px]"
        v-for="(agreement, index) in startScreenAgreement.agreements"
        :key="index"
        v-html="agreement"
      ></li>
    </ul>

    <div class="mt-[14px] text-left" v-if="startScreenAgreement.showTermsAndConditions">
      By continuing, you confirm the above statements and agree to {{ companyName }}'s
      <a href="/terms" target="_blank">Terms & Conditions</a> and
      <a href="/privacy" target="_blank"> Privacy Policy </a>
    </div>
    <button
      class="mt-[32px] mb-[16px] md:mt-[40px] text-[18px] font-medium w-full h-[70px] md:w-[414px] primary-btn"
      v-on:click="start()"
    >
      <div class="flex justify-center items-center gap-[19px]">
        <span>
          {{ isDe ? "Ja, trifft alles zu" : "Agree and continue" }}
        </span>
        <BlackRightArrow class="d-none arrow-right-icon" />
        <img
          class="d-block share-icons"
          src="/resources/img/icons/white_right_arrow.svg"
          alt=""
          width="26"
          height="16"
          style="width: 26px; height: 16px"
        />
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
// disable all rules with !! and use just vue-svg-loader
import BlackRightArrow from "@/ComponentLibrary/assets/arrow_right.svg?inline";

import { Component } from "vue/types/umd";
import { StartScreenAgreement } from "@/Consultation/types";

export default Vue.extend({
  props: {
    start: {
      type: Function as PropType<() => void>,
      required: true,
    },
    startScreenAgreement: {
      type: Object as PropType<StartScreenAgreement>,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  components: {
    BlackRightArrow: BlackRightArrow as Component,
  },
  computed: {
    themeHeadingClasses(): string {
      return this.theme === "levity" ? "text-[25px] md:text-[32px]" : "text-[24px] font-bold text-ziphealth-title-blue";
    },
    isDe(): boolean {
      return process.env.REGION === "de";
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind components;
</style>
